<template>
  <div>
    <h1>Write news</h1>
    <form action="javascript:void(0);">
      <div class="card mb-3" style="max-width: 480px">
        <div class="card-body">
          <label for="formFile" class="form-label"><h5>Picture</h5></label>

          <!-- Picture input group -->
          <div>
            <label class="form-label description" style="font-size: small">
              To add a Picture type URL in the input below.
            </label>

            <!-- URL input group -->
            <div class="input-group mb-3">
              <input
                id="url"
                type="url"
                class="form-control"
                v-model="news.picture"
                placeholder="Add URL"
              />
              <button
                class="btn btn-outline-secondary-custom"
                type="button"
                id="button-addon2"
              >
                <i class="bi bi-card-image"></i>
              </button>
            </div>

            <!-- Image preview -->
            <div v-if="isValidUrl(news.picture)" class="mb-3">
              <img :src="news.picture" class="img-fluid rounded" />
            </div>
          </div>

          <!-- Add news title -->
          <label for="title"><h5>Title</h5></label>
          <input
            id="title"
            type="text"
            class="form-control mb-3"
            v-model="news.title"
            placeholder="Add news title"
          />

          <!-- Add news text -->
          <label for="text">Text</label>
          <textarea
            id="text"
            class="form-control mb-3"
            rows="10"
            v-model="news.text"
            placeholder="Add news text"
          ></textarea>

          <div v-if="isEditing">
            <label for="date">Date</label>
            <input
              id="date"
              type="datetime-local"
              class="form-control mb-3"
              v-model="localDate"
              placeholder="Select Date"
            />
          </div>

          <!-- Users list -->
          <div class="dropdown mt-3 w-100">
            <button
              class="btn btn-outline-secondary dropdown-toggle w-100 btn-lg"
              type="button"
              id="dropdownMenuButton"
              data-bs-toggle="dropdown"
              data-bs-auto-close="outside"
              aria-expanded="false"
              style="height: 50px; font-size: large"
            >
              Send news to...
            </button>
            <ul
              class="dropdown-menu w-100"
              aria-labelledby="dropdownMenuButton"
            >
              <li v-for="(user, index) in usersList" :key="index">
                <label
                  class="dropdown-item d-flex justify-content-between align-items-center"
                  @click.stop
                >
                  <span style="user-select: none"
                    >{{ index + 1 }}. {{ user.name }}</span
                  >
                  <input
                    type="checkbox"
                    class="form-check-input"
                    v-model="news.towhom"
                    :value="user.uid"
                    @click.stop
                  />
                </label>
              </li>
            </ul>
          </div>

          <!-- Show input group to publish -->
          <button
            @click="toggleInput"
            class="btn btn-primary mt-3"
            :disabled="!canPublish"
          >
            Publish
          </button>

          <!-- Confirm action -->
          <div class="form-group mt-3" v-if="confirmWord">
            <ActionConfirm
              :action="confirmWord"
              @confirm="sendCmdNewsSet"
              @cancel="doCancelConfirm"
            />
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import ActionConfirm from "../ActionConfirm.vue";

const cmdNewsSet = "news.set";
const cmdNewsGet = "news.get/";
const cmdLoginUsersList = "login.users.list";

export default {
  name: "PageWriteNews",
  components: {
    ActionConfirm,
  },

  data() {
    return {
      news: { title: "", text: "", picture: "", towhom: [] },
      showActionConfirm: false,
      confirmWord: "",
      usersList: [],
    };
  },

  mounted() {
    let that = this;

    this.previousHref = window.location.href;

    // Add 'reader' which will receive data from WebRTC Data Channel
    this.reader = this.teoweb.addReader(function (gw, data) {
      // Process answer to commands
      switch (gw.command) {
        case cmdLoginUsersList:
          if (gw.err) {
            break;
          }
          that.usersList = JSON.parse(data);
          that.usersList.sort((a, b) => (a.name > b.name ? 1 : -1));
          break;
      }
    });

    // Get url parameters if url changed
    window.addEventListener("popstate", this.popstateListener);

    this.whenLogin.then(() => {
      const id = that.getUrlParameters();
      this.sendCmdNewsGet(id);

      that.teoweb.sendCmd(cmdLoginUsersList);
    });
  },

  unmounted() {
    window.removeEventListener("popstate", this.popstateListener);
  },

  watch: {
    "news.picture"(newValue) {
      if (!this.isValidUrl(newValue)) {
        this.news.picture = "";
      }
    },
  },

  computed: {
    canPublish() {
      return (
        this.news.title.trim().length > 0 || this.news.text.trim().length > 0
      );
    },

    isEditing() {
      return !!this.news.ID;
    },

    localDate: {
      get() {
        if (this.isEditing && this.news.Date) {
          // Convert the date from the server to a Date object
          const date = new Date(this.news.Date);
          const pad = (num) => String(num).padStart(2, "0");
          // Convert to a format that input datetime-local accepts: YYYY-MM-DDTHH:mm
          return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
            date.getDate()
          )}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
        }
        return "";
      },
      set(value) {
        this.news.Date = new Date(value).toISOString();
      },
    },
  },

  methods: {
    // Method sendCmdNewsSet writes data to database
    sendCmdNewsSet() {
      const towhomArray = Array.isArray(this.news.towhom)
        ? this.news.towhom
        : this.news.towhom.trim()
        ? this.news.towhom.split(",")
        : [];
      this.news.towhom = towhomArray
        .map((uid) => window.teoHashKey(uid))
        .join(",");

      this.teoweb.sendCmd(cmdNewsSet, JSON.stringify(this.news));

      this.doCancelConfirm();
      this.resetForm();
    },

    sendCmdNewsGet(id) {
      this.sendCmd(cmdNewsGet + id).then(
        (data) => {
          this.news = JSON.parse(data);
        },
        // Process an error
        (err) => console.error("cmdNewsGet error:", err)
      );
    },

    // Method resetForm clears form after publish news
    resetForm() {
      this.news = { title: "", text: "", picture: "", towhom: [] };
    },

    // Method toggleInput shows or hides confirm group
    toggleInput() {
      this.showActionConfirm = !this.showActionConfirm;

      if (this.showActionConfirm) {
        this.confirmWord = {
          name: "publish",
          text: "Are you sure you want to publish this news?",
          word: "confirm",
        };
      } else {
        this.confirmWord = null;
      }
    },

    doCancelConfirm() {
      this.confirmWord = null;
    },

    isValidUrl(url) {
      try {
        return Boolean(new URL(url));
      } catch (e) {
        return false;
      }
    },

    getUrlParameters(saveHistory = false) {
      const currentPath = window.location.hash;
      // Check if current path is #/write_news
      if (!/#\/(write_news)\/?/.test(currentPath)) return;

      const href = window.location.href;
      const [, , id] = currentPath.split("/");

      // Save to browser history
      if (saveHistory) {
        history.replaceState({}, "", this.previousHref);
        history.pushState({}, "", href);
      }

      this.previousHref = href;

      return id;
    },

    popstateListener() {
      this.getUrlParameters(true);
    },
  },
};
</script>

<style scoped>
.btn-outline-secondary-custom {
  --bs-btn-color: #6c757d;
  --bs-btn-border-color: #dee2e6;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #6c757d;
  --bs-btn-hover-border-color: #6c757d;
  --bs-btn-focus-shadow-rgb: 108, 117, 125;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #6c757d;
  --bs-btn-active-border-color: #6c757d;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #6c757d;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #6c757d;
  --bs-gradient: none;
  border: var(--bs-border-width) solid var(--bs-border-color);
}
</style>
